/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Client_Not_FoundInputs */

const en_api_error_client_not_found = /** @type {(inputs: Api_Error_Client_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client not found.`)
};

const pt_br2_api_error_client_not_found = /** @type {(inputs: Api_Error_Client_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente não encontrado.`)
};

/**
* | output |
* | --- |
* | "Client not found." |
*
* @param {Api_Error_Client_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_client_not_found = /** @type {((inputs?: Api_Error_Client_Not_FoundInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Client_Not_FoundInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_client_not_found(inputs)
	return pt_br2_api_error_client_not_found(inputs)
});